// extracted by mini-css-extract-plugin
module.exports = {"clan_logo_class":"ClanEmblem_clan_logo_class__2sKqb"};